<div class="container-fluid">
  <div class="header-container">
    <div class="page-header">
      <span class="fa fa-clipboard"></span>{{ "bikeshop.shop_setup.card_headers.referrals" | translate }}
    </div>
    <div style="margin-left: auto;">
      <button pButton style="width: 120px;" type="button" class="p-button-raised alternate"
              label="{{ 'bikeshop.service_types.add_new' | translate }}"
              (click)="showReferralItem(null, true)"></button>
    </div>
  </div>
  <div style="display: flex">
    <div style="margin-left: auto">
      <p-progressSpinner *ngIf="loading" [style]="{ width: '30px', height: '30px' }"
                         strokeWidth="2" fill="transparent" animationDuration=".5s"></p-progressSpinner>
    </div>
    <!--<div class="p-inputgroup">
      <input type="text" pInputText [(ngModel)]="search" placeholder="{{
              'general.search' | translate
            }}" (keyup)="inputChanged()" (ngModelChange)="search = $event.toUpperCase()" />
      <span class="p-inputgroup-addon"><i class="fa hubtiger-search" (click)="inputChanged()"></i></span>
    </div>-->
  </div>

  <div class="content margin-top-16">
    <p-table #saleListTable [columns]="columns" [value]="referrals" [paginator]="true" [rows]="20"
             *ngIf="referralsLoaded">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [ngStyle]="{'width': 'auto'}">
            {{ col.header }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-referralItem let-columns="columns">
        <tr [pSelectableRow]="referralItem" style="cursor: pointer"
            (click)="showReferralItem(referralItem, false)">
          <td *ngFor="let col of columns">

            <div *ngIf="col.field == 'IsActive'">
              <div *ngIf="getBooleanValue(referralItem[col.field])" style="color:green;"><i
                class="fa fa-check" aria-hidden="true"></i></div>
              <div *ngIf="!getBooleanValue(referralItem[col.field])" style="color:red"><i
                class="fa fa-times" aria-hidden="true"></i></div>
            </div>
            <div *ngIf="col.field == 'OnlyIfNewCustomer'">
              <div *ngIf="getBooleanValue(referralItem[col.field])"><i class="fa fa-check"
                                                                       aria-hidden="true"></i></div>
              <div *ngIf="!getBooleanValue(referralItem[col.field])"><i class="fa fa-times"
                                                                        aria-hidden="true"></i></div>
            </div>
            <div *ngIf="col.field != 'IsActive' && col.field != 'OnlyIfNewCustomer'">{{ referralItem[col.field] }}</div>

          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar #NavSideBar [(visible)]="showReferral" position="right"
           [style]="{width:'62em', background: '#F6F6F8', 'overflow-x': 'auto'}"
           (onHide)="closeReferral(); NavSideBar.destroyModal()">
  <div *ngIf="showReferral">
    <div class="container-fluid">

      <div>
        <div class="margin-top-8">
          <div class="header">
            {{ 'bikeshop.referrals.add_referral_code' | translate }}
          </div>
          <div class="referral_description">
            {{ 'bikeshop.referrals.short_description' | translate }}
          </div>
        </div>

        <div class="margin-top-8 info-container content">
          <p-progressSpinner *ngIf="loading" [style]="{ width: '30px', height: '30px' }"
                             strokeWidth="2" fill="transparent" animationDuration=".5s"></p-progressSpinner>


          <div>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.description' | translate }}
              </div>
              <div class="col-md-8 value">
                <input id="float-input" type="text" pInputText
                       placeholder="Description" [(ngModel)]="referral.Description"/>
              </div>
            </div>

            <hr/>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.prefix' | translate }}
              </div>
              <div class="col-md-8 value">
                <input id="float-input" type="text" pInputText placeholder="Prefix"
                       [(ngModel)]="referral.ReferralPrefix"/>
                <small>{{ 'bikeshop.referrals.prefix_description' | translate }}</small>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.length' | translate }}
              </div>
              <div class="col-md-3 value">
                <div class="p-inputgroup">
                  <input type="number" pInputText [(ngModel)]="referral.ReferralCodeLength" max="20"
                         min="10" value="10"/>
                </div>
              </div>
            </div>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.suffix' | translate }}
              </div>
              <div class="col-md-8 value">
                <input id="float-input" type="text" pInputText placeholder="Suffix"
                       [(ngModel)]="referral.ReferralSuffix"/>
                <small>{{ 'bikeshop.referrals.suffix_description' | translate }}</small>
              </div>
            </div>

            <hr/>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.only_if_new_customer' | translate }}
              </div>
              <div class="col-md-2 value">
                <p-inputSwitch [(ngModel)]="referral.OnlyIfNewCustomer"></p-inputSwitch>
              </div>
            </div>

            <hr/>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.amount_per_referral' | translate }}
              </div>
              <div class="col-md-3 value">
                <div class="p-inputgroup">
                  <input type="number" pInputText [(ngModel)]="referral.ReferralRewardAmount" min="1"
                         value="1"/>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.maximum_a_client_can_earn' | translate }}
              </div>
              <div class="col-md-3 value">
                <div class="p-inputgroup">
                  <input type="number" pInputText [(ngModel)]="referral.ReferralMaximumEarnings"
                         min="1"/>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.expires_in' | translate }}
              </div>
              <div class="col-md-3 value">
                <div class="p-inputgroup">
                  <input type="number" pInputText [(ngModel)]="referral.ExpiresInMonths" min="1"/>
                </div>
              </div>
            </div>

            <hr/>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.alert_message' | translate }}
              </div>
              <div class="col-md-8 value">
                                <textarea rows="3" id="float-input" type="text" pInputText
                                          [(ngModel)]="referral.AlertMessage"></textarea>
                <small>{{ 'bikeshop.referrals.alert_message_description' | translate }}</small>
              </div>
            </div>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.alert_message_delay' | translate }}
              </div>
              <div class="col-md-8 value">
                <input type="number" pInputText [(ngModel)]="referral.AlertMessageDelay" min="1"/>
              </div>
            </div>


            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.template_message' | translate }}
              </div>
              <div class="col-md-8 value">
                                <textarea rows="3" id="float-input" type="text" pInputText
                                          [(ngModel)]="referral.TemplateMessage"></textarea>
                <small>{{ 'bikeshop.referrals.template_message_description' | translate }}</small>
              </div>
            </div>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.template_message_delay' | translate }}
              </div>
              <div class="col-md-8 value">
                <input type="number" pInputText [(ngModel)]="referral.TemplateMessageDelay" min="1"/>
              </div>
            </div>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.notification_message' | translate }}
              </div>
              <div class="col-md-8 value">
                                <textarea rows="3" id="float-input" type="text" pInputText
                                          [(ngModel)]="referral.NotificationMessage"></textarea>
                <!--<small>{{ 'bikeshop.referrals.alert_message_description' | translate }}</small>-->
              </div>
            </div>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.confirmation_message' | translate }}
              </div>
              <div class="col-md-8 value">
                                <textarea rows="3" id="float-input" type="text" pInputText
                                          [(ngModel)]="referral.ConfirmationMessage"></textarea>
                <!--<small>{{ 'bikeshop.referrals.alert_message_description' | translate }}</small>-->
              </div>
            </div>

            <hr/>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.apply_on' | translate }}
              </div>
              <div class="col-md-8 value">
                <p-multiSelect [options]="statuses" [(ngModel)]="referral.ApplyOn" [filter]="false"
                               placeholder="Choose"
                               [showToggleAll]="false" optionLabel="name"></p-multiSelect>
                <small>{{ 'bikeshop.referrals.apply_on_description' | translate }}</small>
              </div>
            </div>
            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.redeem_on' | translate }}
              </div>
              <div class="col-md-8 value">
                <p-multiSelect [options]="statuses" [(ngModel)]="referral.RedeemOn" [filter]="false"
                               placeholder="Choose"
                               [showToggleAll]="false" optionLabel="name"></p-multiSelect>
                <small>{{ 'bikeshop.referrals.redeem_on_description' | translate }}</small>
              </div>
            </div>

            <hr/>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ 'bikeshop.referrals.active' | translate }}
              </div>
              <div class="col-md-2 value">
                <p-inputSwitch [(ngModel)]="referral.IsActive"></p-inputSwitch>
              </div>
            </div>

            <hr/>


            <!--<div class="row margin-top-16">
               <div class="col-md-4 label"
                    [ngClass]="{'red bold': coupon.redeemMethod === undefined || coupon.redeemMethod.length === 0}">
                 *{{ 'bikeshop.coupons.redeem_method' | translate }}
               </div>
               <div class="col-md-8 value">
                 <p-dropdown [options]="redeemMethodOptions" [(ngModel)]="coupon.redeemMethod" [disabled]="expired">
                 </p-dropdown>
               </div>
             </div>
             <div class="row margin-top-16">
               <div class="col-md-4 label" [ngClass]="{'red bold': coupon.type === undefined || coupon.type.length === 0}">
                 *{{ 'bikeshop.coupons.type' | translate }}
               </div>
               <div class="col-md-8 value">
                 <div>
                   <p-radioButton name="type" value="FIXED_VALUE" label="{{ 'bikeshop.coupons.fixed_value' | translate }}"
                                  [disabled]="expired" [(ngModel)]="coupon.type"></p-radioButton>
                 </div>
                 <div style="margin-top: 4px">
                   <p-radioButton name="type" value="PERCENT" label="{{ 'bikeshop.coupons.percent' | translate }}"
                                  [disabled]="expired" [(ngModel)]="coupon.type"></p-radioButton>
                 </div>
               </div>
             </div>
             <div class="row margin-top-16" *ngIf="isLightSpeed">
               <div class="col-md-4 label"
                    [ngClass]="{'red bold': coupon.lightSpeedDiscountID === null || coupon.lightSpeedDiscountID === undefined || coupon.lightSpeedDiscountID.length === 0}">
                 *{{
  'bikeshop
   .coupons.lightspeed_discount' | translate
                 }}


               </div>
               <div class="col-md-8 value">
                 <p-dropdown [options]="getLightSpeedDiscountOpitons()" [(ngModel)]="coupon.lightSpeedDiscountID" placeholder="{{'bikeshop.coupons.select_a_discount' | translate }}" [disabled]="expired || lightSpeedDiscountOpitons.length === 0" (onChange)="lightSpeedDiscountSelected($event)">
                 </p-dropdown>
               </div>
             </div>-->
            <!--<div class="row margin-top-16">
    <div class="col-md-4 label">
      {{ 'bikeshop.coupons.only_for_first_time_clients' | translate }}
    </div>
    <div class="col-md-2 value">
      <p-inputSwitch [(ngModel)]="coupon.forNewClientsOnly" [disabled]="expired"></p-inputSwitch>
    </div>
  </div>-->


            <div class="row margin-top-16">
              <div class="col-md-4"></div>
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <!--<button pButton (click)="save()" class="p-button-raised full-width" label="{{'bikeshop.general.save' | translate}}" [disabled]="saving || loading || !valid() || editingCouponCode"></button>-->
                <button pButton (click)="save()" class="p-button-raised full-width"
                        label="{{'bikeshop.general.save' | translate}}"
                        [disabled]="!validate()"></button>
              </div>

            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</p-sidebar>
